import React from "react";
import { TimePicker } from "..";
import { usePrevious } from "utilities";
import moment from "moment";
import { FormDatePickerProps, FormDatePickerBase } from "./DatePickerBase";
import { Checkbox } from "../Atoms/inputs/Checkbox";

interface OptionalDateTimePickerProps extends Omit<FormDatePickerProps, "value" | "onChange"> {
  value: moment.Moment | null
  onChange: (value: moment.Moment | null, fromCalendar: boolean) => void;
  initialDateAfterToggleOn?: moment.Moment
}

const OptionalDateTimePicker = (props: OptionalDateTimePickerProps) => {
  const { initialDateAfterToggleOn, value, onChange, ...rest } = props;
  const previousValue = usePrevious(value);

  const onTimeChange = (timeMoment: moment.Moment) => {
    const oldDate = value.clone();

    oldDate.set({
      hour: timeMoment.get("hour"),
      minute: timeMoment.get("minute"),
      second: timeMoment.get("second")
    });

    onChange(oldDate, false);
  };

  const onDisplayChecked = (checked: boolean) => {
    if (checked) {
      if (previousValue == null) {
        onChange(initialDateAfterToggleOn ?? moment.utc().startOf("day"), false);
      } else {
        onChange(previousValue, false);
      }
    } else {
      onChange(null, false);
    }
  };

  return <div className="flex gap-small">
    <div className="padding-left">
      <Checkbox
        className="margin-right-small"
        checked={value != null}
        onChange={(_, checked) => { onDisplayChecked(checked); }}
      />
    </div>
    {value != null && <div className="flex">
      <FormDatePickerBase
        mode="single"
        value={value}
        onChange={onChange}
        {...rest}
      />
      <div className="margin-left-small">
        <TimePicker
          value={value}
          onChange={onTimeChange}
        />
      </div>
    </div>}
  </div>;
};

export default OptionalDateTimePicker;